import script from "./EditIndividualBusinessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditIndividualBusinessModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditIndividualBusinessModal.vue?vue&type=style&index=0&id=a87cbaa2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a87cbaa2"]])

export default __exports__